"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHIPPING_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
exports.SHIPPING_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment Shipping on Shipping {\n    id\n    consumablesPerCase\n    productsPerCase\n  }\n"], ["\n  fragment Shipping on Shipping {\n    id\n    consumablesPerCase\n    productsPerCase\n  }\n"])));
var templateObject_1;
